import {
  ObservableState,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import { SidebarPanelContentIds, SidebarPanelState } from './types';
import {
  closeSidebarPanel,
  openSidebarPanel,
  toggleSidebarPanel,
} from './actions';
import { sidebarPanelCommands } from './sidebarPanelCommands';

const defaultState: SidebarPanelState = {
  contentId: null,
  commands: sidebarPanelCommands,
};

const handleOpenSidebarPanel = (
  state: SidebarPanelState,
  contentId: SidebarPanelContentIds
): SidebarPanelState => ({
  ...state,
  contentId,
});

const handleToggleSidebarPanel = (
  state: SidebarPanelState,
  contentId: SidebarPanelContentIds
): SidebarPanelState => ({
  ...state,
  contentId: contentId === state.contentId ? null : contentId,
});

const handleCloseSidebarPanel = (
  state: SidebarPanelState
): SidebarPanelState => ({
  ...state,
  contentId: null,
});

export const sidebarPanel$: ObservableState<SidebarPanelState> =
  persistentReducedStream('sidebarPanel$', defaultState, [
    reducer(openSidebarPanel, handleOpenSidebarPanel),
    reducer(closeSidebarPanel, handleCloseSidebarPanel),
    reducer(toggleSidebarPanel, handleToggleSidebarPanel),
  ]);
